import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-12",
  "use": "menu-12-usage",
  "viewBox": "0 0 164.4 152.07",
  "content": "<symbol viewBox=\"0 0 164.4 152.07\" id=\"menu-12\"><title>资源 115</title><g id=\"menu-12_图层_2\" data-name=\"图层 2\"><g id=\"menu-12_图层_1-2\" data-name=\"图层 1\"><path d=\"M154.13,16.44H141.8V6.17a6.17,6.17,0,0,0-12.33,0V16.44H107.55V6.17a6.17,6.17,0,0,0-12.33,0V16.44H73.31V6.17A6.17,6.17,0,0,0,61,6.17V16.44H39V6.17a6.17,6.17,0,0,0-12.33,0V16.44H10.28A10.28,10.28,0,0,0,0,26.72V129.47a10.28,10.28,0,0,0,10.28,10.28H24.66V148a4.12,4.12,0,0,0,4.11,4.11H53.43A4.12,4.12,0,0,0,57.54,148v-8.22h49.32V148a4.12,4.12,0,0,0,4.11,4.11h24.66a4.12,4.12,0,0,0,4.11-4.11v-8.22h14.39a10.28,10.28,0,0,0,10.28-10.28V26.72A10.29,10.29,0,0,0,154.13,16.44ZM108.53,73.1,79.76,114.2a2.07,2.07,0,0,1-1.69.88,2.21,2.21,0,0,1-.77-.16,2,2,0,0,1-1.25-2.23l4.37-26.38H61.65A2,2,0,0,1,60,83L88.8,46a2.08,2.08,0,0,1,2.52-.58,2,2,0,0,1,1.09,2.34L86.89,69.87h20A2.07,2.07,0,0,1,108.67,71,2,2,0,0,1,108.53,73.1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-12.svg
// module id = qjFN
// module chunks = 264